import { render } from "./404View.vue?vue&type=template&id=737ebadf"
const script = {}

import exportComponent from "/OfficialWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__